export const pipelineProvideInjectKeys = {
  PIPELINE_OPERATION_ID: Symbol('PIPELINE_OPERATION_ID')
};

// 企业2 组织0 项目1
export enum INVITE_SOURCE_TYPE {
  GROUP = '0',
  REPO = '1',
  ENTERPRISE = '2',
}

// ac新服务路径
export const AC_NEW_URL = '/api/v2/ac';
